import $ from 'jquery';

$.fn.updateCharCount = function (target, maxLength) {
  this.each(function () {
    var input = $(this);
    $.each(
      ['keydown', 'keyup', 'change', 'click', 'focus', 'blur'],
      function () {
        input
          .off(this + '.update-char-count')
          .on(this + '.update-char-count', function () {
            $(target).text(Math.max(0, maxLength - $(this).val().length));
          });
      },
    );
    input.trigger('change');
  });
  return this;
};

$('form').on(
  'keydown',
  'input[type="text"], input[type="email"], input[type="password"]',
  function (e) {
    if (e.which === 0x0d) {
      $(this).closest('form').trigger('submit');

      return false;
    }
    return true;
  },
);
